/**
 * @generated SignedSource<<773aa465217f75d760411147dd90707d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type createPersonalizedNotificationTemplateButton_Refetch$variables = {};
export type createPersonalizedNotificationTemplateButton_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment">;
};
export type createPersonalizedNotificationTemplateButton_Refetch = {
  response: createPersonalizedNotificationTemplateButton_Refetch$data;
  variables: createPersonalizedNotificationTemplateButton_Refetch$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "createPersonalizedNotificationTemplateButton_Refetch",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "createPersonalizedNotificationTemplateButton_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationAdminSchema",
            "kind": "LinkedField",
            "name": "Notification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationTemplate",
                "kind": "LinkedField",
                "name": "GetAvailableNotificationTemplates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f9d04d4d1f3d851d3c328b393e5c5e69",
    "id": null,
    "metadata": {},
    "name": "createPersonalizedNotificationTemplateButton_Refetch",
    "operationKind": "query",
    "text": "query createPersonalizedNotificationTemplateButton_Refetch {\n  ...createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment\n}\n\nfragment createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment on Query {\n  Admin {\n    Notification {\n      GetAvailableNotificationTemplates {\n        key\n        title\n      }\n    }\n  }\n}\n"
  }
};

(node as any).hash = "b5255375ff27ca3cbbdf589cdeb0a1d9";

export default node;
